// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { doesNotHaveExpand, get } from "@insite/client-framework/Services/ApiService";
import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import { OrderCollectionModel, OrderModel } from "@insite/client-framework/Types/ApiModels";

const ordersUrl = "/api/v1/orders";

// @override to delete the orderTotalOperator and orderTotal parameters when one of them empty
// to get the correct orders (RUG-599 bug solution)
export async function getOrders(parameter: GetOrdersApiParameter): Promise<OrderCollectionModel> {
    // can't send empty status array to API
    if (parameter.status && parameter.status.length === 0) {
        delete parameter.status;
    }

    if (parameter?.orderTotalOperator && !parameter?.orderTotal) {
        delete parameter.orderTotalOperator;
    }

    if (parameter?.orderTotal && !parameter?.orderTotalOperator) {
        delete parameter.orderTotal;
    }

    const orders = await get<OrderCollectionModel>(ordersUrl, parameter);
    orders.orders?.forEach(o => {
        cleanOrder(o, parameter);
    });
    return orders;
}

// @override the same ootb function to use it inside the getOrders function
function cleanOrder(orderModel: OrderModel, parameter?: { expand?: string[]; additionalExpands?: string[] }) {
    orderModel.orderDate = new Date(orderModel.orderDate);
    orderModel.id = orderModel.erpOrderNumber || orderModel.webOrderNumber;
    if (doesNotHaveExpand(parameter, "orderLines")) {
        delete orderModel.orderLines;
    }
}
